import { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const location = useLocation();
  const token = localStorage.getItem("adminToken");

  useEffect(() => {
    // Token kontrolü yap
    if (!token) {
      console.log("Token bulunamadı, giriş sayfasına yönlendiriliyor...");
    }
  }, [token]);

  // Token yoksa admin-login sayfasına yönlendir
  if (!token) {
    return <Navigate to="/admin-login" state={{ from: location }} replace />;
  }

  // Token varsa içeriği göster
  return <>{children}</>;
}
